import React, { useState } from 'react';
import charterLockup from '../assets/charter-lockup.png';
import { CURRENT_SITE } from '../../config-sites';

export const processMetatags = (
    metatags: {
        tag: string;
        attributes: {
            content: string;
            property: string;
            href: string;
            name: string;
            rel: string;
        };
    }[],
    isPolicy?: boolean
) => {
    const outTags: JSX.Element[] = [];
    const checkURL = (contentString) => {
        try {
            return Boolean(new URL(contentString));
        } catch (e) {
            return false;
        }
    };

    if (!metatags) return [];

    for (const metatag of metatags.filter(
        (metatag) =>
            metatag.tag !== `link` &&
            (metatag.attributes.name || metatag.attributes.property)
    )) {
        if (
            metatag.attributes?.property?.includes(`image`) ||
            metatag.attributes?.name === `twitter:image`
        ) {
            if (checkURL(metatag.attributes?.content)) {
                const newURL = new URL(metatag.attributes?.content);
                newURL.hostname = isPolicy
                    ? `policy.charter.com`
                    : `corporate.charter.com`;
                metatag.attributes.content = newURL.toString();
            }
        }

        if (metatag.attributes?.property === `og:image`) {
            metatag.attributes.name = `image`;
        }
        const elem = React.createElement(metatag.tag, {
            ...metatag.attributes,
            id: metatag.attributes.name
                ? metatag.attributes.name
                : metatag.attributes.property,
            key: `head-${JSON.stringify(metatag)}`,
        });

        outTags.push(elem);
    }

    if (!outTags.find((tag) => tag.type === `title`)) {
        const titleTag = metatags.find(
            (tag) => tag.attributes.name === `title`
        );
        if (titleTag) {
            const titleVal = titleTag.attributes.content;
            outTags.push(
                <title id="title" key="page-title">
                    {titleVal}
                </title>
            );
        } else {
            outTags.push(
                <title id="title" key="page-title">
                    {CURRENT_SITE.siteTitleSuffix}
                </title>
            );
        }
    }

    if (isPolicy) {
        const imageUrl =
            typeof window !== `undefined`
                ? window.location.host + charterLockup
                : ``;
        if (!outTags.find((tag) => tag.props.name === `twitter:image`)) {
            outTags.push(
                <meta
                    content={imageUrl.toString()}
                    name="twitter:image"
                    id="twitter:image"
                    key="twitter-image"
                ></meta>
            );
        }

        if (!outTags.find((tag) => tag.props.name === `og:image`)) {
            outTags.push(
                <meta
                    content={imageUrl.toString()}
                    name="og:image"
                    property="og:image"
                    id="og:image"
                    key="og-image"
                ></meta>
            );
        }
    }

    return outTags;
};

export const SharedTags = ({ isPolicy }) => {
    return (
        <>
            <meta
                id="twitter:site"
                name="twitter:site"
                content={`${isPolicy ? `@CharterGov` : `@charternewsroom`}`}
            />
            <meta
                id="twitter:creator"
                name="twitter:creator"
                content={`${isPolicy ? `@CharterGov` : `@charternewsroom`}`}
            />
            <meta
                id="og:image:alt"
                property="og:image:alt"
                content="Social Icon"
            />
            <meta
                id="twitter:card"
                name="twitter:card"
                content="summary_large_image"
            />
        </>
    );
};
